import { Pipe, PipeTransform } from '@angular/core';
import { BENEFIT_NAME } from '@app/config/benefit-name.enum';

@Pipe({
  name: 'benefitName'
})
export class BenefitNamePipe implements PipeTransform {

  transform(value: number): string {

    value = Number(value);

    const ix: number = BENEFIT_NAME.findIndex(e => e.id === value);

    if (ix !== -1)
      return BENEFIT_NAME[ix].name;

    return '';
  }
}
